import {
  BACKGROUND_REPLACE_GENERATION_TYPE,
  LORA_GENERATION_TYPE,
  REFRAME_GENERATION_TYPE,
} from "../../../Board/constants.ts";
import type { ModelGenerationType } from "../../../Board/types.ts";
import {
  type ModelGenerationParams,
  zBackgroundReplaceModelExtraGenerationParams,
  zLoraModelExtraGenerationParams,
  zReframeModelExtraGenerationParams,
} from "./types.ts";

export const updateModelGenerationParams = (
  modelUuid: string,
  allowedModelGenerationTypes: ModelGenerationType[],
  isModelTrained: boolean,
  modelGenerationType: ModelGenerationType,
) => {
  if (!allowedModelGenerationTypes.includes(modelGenerationType)) {
    throw new Error(
      `Model generation type ${modelGenerationType} is not allowed`,
    );
  }

  let newModelGenerationType: ModelGenerationType;
  if (isModelTrained) {
    newModelGenerationType = LORA_GENERATION_TYPE;
  } else {
    newModelGenerationType =
      modelGenerationType === LORA_GENERATION_TYPE
        ? REFRAME_GENERATION_TYPE
        : modelGenerationType;
  }

  let newModelGenerationParams: ModelGenerationParams = {
    uuid: modelUuid,
  };

  switch (newModelGenerationType) {
    case LORA_GENERATION_TYPE:
      newModelGenerationParams = {
        ...newModelGenerationParams,
        model_generation_type: newModelGenerationType,
        ...zLoraModelExtraGenerationParams.parse({}),
      };
      break;
    case REFRAME_GENERATION_TYPE:
      newModelGenerationParams = {
        ...newModelGenerationParams,
        model_generation_type: newModelGenerationType,
        ...zReframeModelExtraGenerationParams.parse({}),
      };
      break;
    case BACKGROUND_REPLACE_GENERATION_TYPE:
      newModelGenerationParams = {
        ...newModelGenerationParams,
        model_generation_type: newModelGenerationType,
        ...zBackgroundReplaceModelExtraGenerationParams.parse({}),
      };
      break;
  }
  return newModelGenerationParams;
};

export const getModelDefaultGenerationParams = (
  modelUuid: string,
  isModelTrained: boolean,
) => {
  const modelGenerationType: ModelGenerationType = isModelTrained
    ? LORA_GENERATION_TYPE
    : REFRAME_GENERATION_TYPE;

  let modelGenerationParamsToAdd: ModelGenerationParams = {
    uuid: modelUuid,
  };

  switch (modelGenerationType) {
    case REFRAME_GENERATION_TYPE:
      modelGenerationParamsToAdd = {
        ...modelGenerationParamsToAdd,
        model_generation_type: modelGenerationType,
        ...zReframeModelExtraGenerationParams.parse({}),
      };
      break;
    case LORA_GENERATION_TYPE:
      modelGenerationParamsToAdd = {
        ...modelGenerationParamsToAdd,
        model_generation_type: modelGenerationType,
        ...zLoraModelExtraGenerationParams.parse({}),
      };
      break;
  }
  return modelGenerationParamsToAdd;
};
